import { render, staticRenderFns } from "./subjectAdvance.vue?vue&type=template&id=499152a9"
import script from "./subjectAdvance.vue?vue&type=script&lang=js"
export * from "./subjectAdvance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports